<template>
  <transition name="fade-out">
    <div :class="['message', className, mobile]" v-if="state">
      <div class="message-mask" v-if="isMask"></div>
      <div class="message-wrap">
        <div class="message-scroll-wrap">
          <div class="message-scroll-box" @click="closeByCv">
            <div :class="['message-content', 'clearfix', size]">
              <div class="message-header clearfix" v-if="title">
                <div class="message-title">{{ title }}</div>
              </div>
              <div class="message-body" v-if="!isDom">{{ text }}</div>
              <div class="message-body" v-if="isDom" v-html="text"></div>
              <div class="message-toolbar" :class="{ freeze }">
                <span v-for="(item, idx) in btns" :key="idx">
                  <a :href="item.href" v-if="item.tag == 'a'" :class="['btn', btnClass(item.type)]"> <i :class="item.icon" v-if="item.icon"></i>{{ item.text }} </a>
                  <button type="button" v-else :class="['btn', btnClass(item.type)]" @click="btnEv(item.callback)"><i :class="item.icon" v-if="item.icon"></i>{{ item.text }}</button>
                </span>
              </div>
              <button type="button" aria-label="Close" class="btn message-close" v-if="showClose" @click="close">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/*
 * @description 弹层組件
 * @author momo
 * @update 2021/06/18
 * @demo Message(text, option)
 * @param text 弹层内容
 * @param option 配置对象，选填
 * @param option => {
 *  className: 'string 自定义class',
 *  title: 'string 弹层标题',
 *  className: 'string 自定义class',
 *  showClose: 'boolean 是否显示右上角关闭按钮',
 *  isDom: 'boolean text字段是不是dom结构',
 *  btns: 'array 按钮组配置，可n个',
 *  size: 弹层尺寸
 *  btns[n]: 'object => {
 *      type: 'string 可选 primary|info|success|warning|danger',
        text: 'string 按钮文字',
        tag:  'string 标签类型',
        href: 'string 标签类型为a时起作用',
        callback: 'function 回调函数，不返回|返回true 则关闭，返回false则不关闭，可返回promise'
 *  }',
 *  closeOnClickModal: 点击背景关闭弹层
 *  callback: 关闭回调
 * 
 */
import Device from 'utils/device'
export default {
  name: 'Message',
  data() {
    return {
      state: false,
      freeze: false,
      mobile: Device.isMobile ? 'mobile' : ''
    }
  },
  props: {
    className: {
      type: String,
      default: ''
    },
    isMask: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '提示'
    },
    text: {
      type: String,
      default: ''
    },
    isDom: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'sm'
    },
    btns: {
      type: Array,
      default() {
        return []
      }
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    callback: {
      type: Function,
      default: null
    }
  },
  methods: {
    btnClass(className) {
      return className ? `btn-${className}` : 'btn-primary'
    },
    btnEv(fn) {
      // 冻结期间不能操作按钮
      if (this.freeze) return

      // 按钮回调
      if (typeof fn === 'function') {
        // 冻结按钮回调
        this.freeze = true

        let cb = fn()

        // promise等待结果
        if (cb instanceof Promise) {
          // 完成执行关闭
          cb.then(this.close)
            // 拒绝解除冻结
            .catch(() => {
              this.freeze = false
            })
        }

        // 返回true或者不返回
        if (cb === undefined || cb === true) {
          this.close()
        } else {
          this.freeze = false
        }
      } else {
        // 不定义回调方法，直接关闭
        this.close()
      }
    },
    close() {
      let result = true

      if (result !== false) {
        this.state = false
      }

      if (typeof this.callback === 'function') {
        result = this.callback()
      }
    },
    closeByCv(ev) {
      if (!ev.target.classList.contains('message-scroll-box') || !this.closeOnClickModal) return

      this.close()
    }
  },
  mounted() {
    this.state = true
  }
}
</script>

<style lang="scss">
.message {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  font-size: 0;
  z-index: 20;
  .message-mask,
  .message-wrap {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .message-mask {
    background-color: rgba(0, 0, 0, 0.5);
  }
  .message-wrap {
    padding: 20px 0;
    overflow: auto;
  }
  .message-scroll-wrap {
    display: table;
    width: 100%;
    height: 100%;
  }
  .message-scroll-box {
    display: table-cell;
    vertical-align: middle;
  }
  .message-content {
    margin: auto;
    position: relative;
    text-align: left;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: #fff;
    &.lg {
      max-width: 1024px;
    }
    &.md {
      max-width: 768px;
    }
    &.sm {
      width: 98%;
      max-width: 414px;
    }
    .message-header {
      position: relative;
      .message-title {
        margin: 15px 15px 5px;
        font-size: 18px;
      }
    }
    .message-body {
      margin: 15px 15px 5px;
      font-size: 14px;
      color: #606266;
    }
    .message-toolbar {
      margin: 10px 15px 15px;
      text-align: right;
      .btn {
        padding: 10px 24px;
        margin-right: 10px;
        font-size: 14px;
        border-radius: 3px;
        .iconfont {
          margin-right: 4px;
          font-size: 14px;
          vertical-align: text-top;
        }
      }
      span:last-child {
        .btn {
          margin-right: auto;
        }
      }

      &.freeze .btn {
        cursor: no-drop;
      }
    }
  }
  .message-close {
    width: 43px;
    height: 43px;
    line-height: 43px;
    padding: 0;
    position: absolute;
    top: 0;
    right: 0;
    text-align: center;
    font-size: 22px;
    font-weight: 300;
    border-radius: 0 4px 0 0;
    color: #606266;
    background-color: transparent;
    &:hover {
      color: #f56c6c;
    }
  }
  &.mobile {
    font-size: 28px !important;
    .message-content {
      &.lg,
      &.md,
      &.sm {
        max-width: 720px;
      }
      &.lg {
        width: 98%;
      }
      &.md {
        width: 80%;
      }
      &.sm {
        width: 72%;
      }
      .message-header {
        .message-title {
          margin: 20px 30px 10px;
          font-size: 32px;
        }
      }
      .message-body {
        margin: 20px 30px 10px;
        font-size: 24px;
      }
      .message-toolbar {
        margin: 20px 30px 30px;
        .btn {
          margin-right: 16px;
          font-size: 24px;
          border-radius: 6px;
          .iconfont {
            margin-right: 8px;
            font-size: 24px;
          }
        }
      }
    }
    .message-close {
      width: 43px;
      height: 43px;
      line-height: 43px;
      font-size: 22px;
      font-weight: 300;
      border-radius: 0 4px 0 0;
    }
  }
}

@media (max-width: 414px) {
  .message {
    .message-content {
      .message-header {
        position: relative;
        .message-title {
          margin: 15px 15px 5px;
          font-size: 18px;
        }
      }
      .message-body {
        margin: 15px 15px 5px;
        font-size: 14px;
      }
      .message-toolbar {
        margin: 10px 15px 15px;
        .btn {
          padding: 7px 15px;
          margin-right: 10px;
          font-size: 14px;
          border-radius: 3px;
          .iconfont {
            margin-right: 4px;
            font-size: 14px;
          }
        }
      }
    }
    .message-close {
      width: 43px;
      height: 43px;
      line-height: 43px;
      font-size: 24px;
      border-radius: 0 4px 0 0;
    }
  }
}
</style>
